import Grid from '@mui/material/Grid';

import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import Skeleton from '@mui/material/Skeleton';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { SocialGrid } from './styles';
import FollowButton from './Follow';
import { getAssociatedOfferings } from 'services/user';
import useIsMobile from 'hooks/useIsMobile';

const UserMenu = dynamic(() => import('./UserMenu'), {
  loading: () => <Skeleton />,
});

const Social = ({ offeringClosed }) => {
  const isMobile = useIsMobile();
  const pathname = usePathname();
  const primaryUserId = useSelector((state) => state.user.primaryUserId);

  // Hide social elements (watchlist, profile) on Canadian pages
  const isCanadianRoute = pathname?.startsWith('/private-canada');

  const { data: associatedOfferings } = useQuery({
    queryKey: ['associatedOfferings'],
    queryFn: () =>
      getAssociatedOfferings({
        primaryUserId,
      }),
    enabled: Boolean(primaryUserId),
  });

  // Don't render social elements on Canadian pages
  if (isCanadianRoute) {
    return null;
  }

  return (
    <SocialGrid
      container
      justifyContent="flex-end"
      alignItems="center"
      sx={isMobile ? { mr: -1 } : { gap: 1 }}
    >
      <Grid item>
        <FollowButton />
      </Grid>
      <Grid item>
        <UserMenu associatedOfferings={associatedOfferings?.data} />
      </Grid>
    </SocialGrid>
  );
};
export default Social;
